export default `
    <footer id="LoginFooter">
        <div id="LoginMsiInfo" class="right">
            #= data.learnMoreAbout # 
            <a id="LoginMsiLink" href="#= data.companyURL #">
                #= data.companyName #
            </a>
        </div>
        <div id="LoginServiceProCopy" class="left">
            © #= data.date # - #= data.app #
        </div>
    </footer>
`;
